export { default as GDMUserProfileHeader } from './GDMUserProfileHeader';

export type { GDMUserProfileHeaderComponent } from './GDMUserProfileHeader.type';

